import { Box, Typography } from '@mui/material'
import wordmark from '../../assets/transparent-wordmark.png'
import { PageSeo } from '../page-seo'
import { FeaturesSection } from './features-section'
import { ParallaxHero } from '../_components/parallax-hero'

const HOME_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'TerraPlanner',
  applicationCategory: 'Farming & Agriculture',
  operatingSystem: 'Web',
  url: 'https://terra-planner.com',
  description: 'Climate-aware crop scheduling for farmers and homesteaders.',
  offers: { '@type': 'Offer', price: '0', priceCurrency: 'USD' },
}

const contentSx = { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }

export const Home = () => (
  <Box>
    <PageSeo
      title="Gardening with Precision"
      description="Plan, track, and optimize your farm from anywhere in the world — powered by real climate data. Free to start, no subscription required."
      path="/"
      schema={HOME_SCHEMA}
    />

    <ParallaxHero contentSx={contentSx}>
      <Box
        component="img"
        src={wordmark}
        alt="TerraPlanner"
        width={200}
        height={50}
        sx={{ height: { xs: 56, md: 72 }, width: 'auto', mb: 1 }}
      />
      <Typography
        variant="h4"
        component="h1"
        fontWeight={600}
        sx={{ maxWidth: 600, opacity: 0.96 }}
      >
        Gardening with Precision
      </Typography>
      <Typography
        variant="body1"
        sx={{ maxWidth: 520, opacity: 0.82, lineHeight: 1.75 }}
      >
        Plan, track, and optimize your farm from anywhere in the world — powered by real climate data.
      </Typography>
    </ParallaxHero>

    <FeaturesSection />
    {/* TODO request invite / setup account link */}
    {/* <CtaSection /> */}
  </Box>
)
